
import partyActions, { ActionTypes } from "../reducers/partyReducers";
import { call, put, takeLatest } from 'redux-saga/effects';


//worker
export function* getAllPartyGoers(){
    try {
        const partyGoers = yield call(getAllPartyGoers);
        yield put(partyActions.getAllPartyGoersSuccessActionCreator(partyGoers));
    } catch (error) {
        console.error("partySaga error (dispatched to store):", error)
        yield put(partyActions.getAllPartyGoersErrorActionCreator(error));
    }
}

//watcher
export function* watchGetAllPartyGoersRequest(){
    yield takeLatest(ActionTypes.GET_ALL_GOERS_REQUEST, getAllPartyGoers)
}